import { render, staticRenderFns } from "./manipulate_note_widget.vue?vue&type=template&id=22d0ad92&scoped=true"
import script from "./manipulate_note_widget.vue?vue&type=script&lang=js"
export * from "./manipulate_note_widget.vue?vue&type=script&lang=js"
import style0 from "./manipulate_note_widget.vue?vue&type=style&index=0&id=22d0ad92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d0ad92",
  null
  
)

export default component.exports